import React, { useCallback } from 'react';

/**
 * The parts of {@link ScopeContext} that the telemetry API actually uses.
 */

export var SentryBrowserIntegration = function SentryBrowserIntegration(_ref) {
  var Listener = _ref.Listener,
    client = _ref.client,
    children = _ref.children;
  return /*#__PURE__*/React.createElement(Listener, {
    onEvent: useCallback(function (_ref2) {
      var exception = _ref2.exception,
        scopeContext = _ref2.scopeContext;
      client.captureException(exception, scopeContext);
    }, [client])
  }, children);
};